export class Error {
  code: string;
  errorList: Object;
}
